/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect, useState} from 'react'
import {initialQueryState, KTIcon, useDebounce} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {phoneMask} from '../../../../chooseFranchise/utils/mask'
import {DocumentSearch} from '../../../../../components/DocumentSearch'
import {removeMask, removeSCMask} from '../../../../../utils/formatMonetaryToBr'
import {MultiSelect, Option} from 'react-multi-select-component'
import {getStatusClient} from '../../core/_requests'
import '../../../../../style/multiSelectSucess.css'
import Swal from 'sweetalert2'

const Search = () => {
  const {state, updateState} = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [searchPhone, setSearchPhone] = useState<string>('')

  const debouncedSearchTerm = useDebounce(searchTerm, 300)
  const debouncedSearchPhone = useDebounce(searchPhone, 300)

  const [clientStatusOption, setClientStatusOption] = useState<Option[]>([{value: '', label: ''}])
  const [statusValue, setStatusValue] = useState<Option[]>([])

  useEffect(() => {
    async function initialize() {
      try {
        const data = await getStatusClient()
        setClientStatusOption(data!)
      } catch (error: any) {
        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error?.response?.data?.message,
          timer: 2000,
        })
      }
    }
    initialize()
  }, [])

  useEffect(() => {
    if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
      updateState({name: debouncedSearchTerm, ...initialQueryState})
    }
  }, [debouncedSearchTerm])

  useEffect(() => {
    if (
      debouncedSearchPhone !== undefined &&
      searchPhone !== undefined &&
      (debouncedSearchPhone.length > 13 || debouncedSearchPhone.length == 0)
    ) {
      updateState({phone: String(removeSCMask(debouncedSearchPhone)), ...initialQueryState})
    }
  }, [debouncedSearchPhone])

  return (
    <div className='card-title'>
      {/* begin::Search */}
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='d-flex align-items-center position-relative my-1'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-1' />
              <input
                type='text'
                data-kt-user-table-filter='name'
                className='form-control form-control-solid w-200px ps-14'
                placeholder='Pesquisar cliente'
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className='col'>
            <div className='d-flex align-items-center position-relative'>
              <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
              <input
                type='text'
                data-kt-user-table-filter='phone'
                className='form-control form-control-solid w-200px ps-14'
                placeholder='Pesquisar telefone'
                value={phoneMask(searchPhone)}
                onChange={(e) => setSearchPhone(e.target.value)}
                maxLength={17}
              />
            </div>
          </div>
          <div className='col'>
            <DocumentSearch
              currentDocument={state.document}
              onSearch={(document) => updateState({document, ...initialQueryState})}
            />
          </div>
          <div className='col'>
            <div className='fv-row'>
              <MultiSelect
                className='form-control w-250px rmscStyle ps-14'
                data-kt-user-table-filter='status'
                options={clientStatusOption}
                value={statusValue}
                onChange={(option) => {
                  const valores = option.map((item) => item.value)
                  updateState({status: String(valores), ...initialQueryState})
                  setStatusValue(option)
                }}
                labelledBy={''}
                shouldToggleOnHover
                overrideStrings={{
                  selectSomeItems: 'Pesquisar por status',
                  search: 'Procurar',
                  selectAll: 'Selecionar todos',
                  allItemsAreSelected: 'Todos status selecionados',
                  selectAllFiltered: 'Selecionar todos (filtrados)',
                  noOptions: 'Nenhuma opção encontrada',
                }}
              />
            </div>
          </div>
        </div>
      </div>
      {/* end::Search */}
    </div>
  )
}

export {Search}
